class SizeChartPopup extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.size-chart-trigger');
    this.modal = this.querySelector('dialog');
    this.closeBtn = this.querySelector('.size-chart-modal__close');

    this.trigger.addEventListener('click', () => this.openModal());
    this.closeBtn.addEventListener('click', () => this.closeModal());
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) this.closeModal();
    });
    this.modal.addEventListener('cancel', (e) => {
      e.preventDefault();
      this.closeModal();
    });
  }

  openModal() {
    this.modal.showModal();
    requestAnimationFrame(() => this.modal.classList.add('is-open'));
  }

  closeModal() {
    this.modal.classList.remove('is-open');
    setTimeout(() => this.modal.close(), 300);
  }
}

customElements.define('size-chart-popup', SizeChartPopup);